import React from 'react';

export const sortCards = [
  {
    id: '1',
    name: 'Chariot',
    prettyName: 'Chariot',
    img: 'notice1.png',
    comment: <p><b>Tara said:</b> Visually, I'm really engaged. I like that it's given in the context
      of
      using app rather than hidden in the T&Cs. The language is user-friendly and succinct. When I
      investigated further though, I realised that it's quite vague about how and why they need my
      data. I'd love a bit more clarity surrounding this and to feel more in control as a user.</p>
  },
  {
    id: '2',
    name: 'MobileStreaming',
    prettyName: 'Mobile Streaming',
    img: 'notice2.png',
    comment: <p><b>Tommy said:</b> While the design is really inviting, the notice does not clearly
      really tell me what data they are capturing and why the app needs it. As a user I feel like my
      control options are limited to only accepting. The language is also too simple and succinct
      that it is not informative.</p>
  },
  {
    id: '3',
    name: 'Loco',
    prettyName: 'Loco',
    img: 'notice3.png',
    comment: <p><b>Anthony said:</b> I understand that my data is going overseas and to their partners for
      analytics, personalisation and ads. It is not transparent to me why they need all this data
      and what is the value exchange for me? The technical terminology isn't very accessible and I
      can’t see any option to reject or limit my data transfer. The design is user-friendly.</p>
  },
  {
    id: '4',
    name: 'Friendlee',
    prettyName: 'Friendlee',
    img: 'notice5.png',
    comment: <p><b>Nicole said:</b> The design is ok in term of information heirarchy and aesthetic, but
      the T&Cs are hidden in small texts and a hyperlink. The language is too vauge and brief. I
      feel my only options is to sign up and accept. As I user I feel disempowered and that this
      company is not being transparent with my data.</p>
  },
  {
    id: '5',
    name: 'Shelte',
    prettyName: 'Shelte',
    img: 'notice6.png',
    comment: <p><b>Sarah said:</b> While this notice is explicit and clear in telling me where and how my
      data is being used, the legal jargon and technical terms were hard to follow. The design could
      be more inviting and I can’t read the text in yellow easily. I like that I can access
      information, but I can only see ‘agree and proceed’ as the control option, which seems
      skewed.</p>
  },
  {
    id: '6',
    name: 'Micasa',
    prettyName: 'Micasa',
    img: 'notice7.png',
    comment: <p><b>Janine said:</b> I like how accessible and conversational the language is, but the value
      exchange is still a bit vague and unclear. I would like clearer informartion about how they
      are using my data and what it might do for me. The design is engaging and there is a clear
      heirarchy of information. The control options seem to empower me as the user.</p>
  },
  {
    id: '7',
    name: 'Loco2',
    prettyName: 'Loco 2',
    img: 'notice4.png',
    comment: <p><b>Jason said:</b> This notice felt very transparent to me. They have explained clearly why
      they need access to the different types of data, in the context of the app. The language is
      simple and easy to understand. I was enganged by the icons and visual design. I also have
      control whether I allow each of
      these permissions.</p>
  },
  {
    id: '8',
    name: 'Friendlee2',
    prettyName: 'Friendlee 2',
    img: 'notice0.png',
    comment: <p><b>Riley said:</b> While I like that there are options to learn and read more, I don’t
      think many people will read this. The context and value exchange isn’t obvious upfront. It’s
      positive that you can op-out or turn off settings, but these controls feel hidden from the
      user. The language could be more succinct with clear dot points of the data usage and
      visuals.</p>
  },
];
